export enum DialogActionType {
  cancel = 'cancel',
  submit = 'submit',
  reload = 'reload',
}
